import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../actions';
import { addConfig } from '../actions/ConfigActions';
import { getAuthHeader } from '../util/authHeaderConfig';

export const PacsSelector = () => {
  const dispatch = useDispatch();
  const appConfig = useSelector((state) => state.config);

  const { PACS_SELECTOR_CONFIG, WITH_PACS_SELECTOR } = appConfig;

  const [selectedPacsIndex, setSelectedPacsIndex] = useState(sessionStorage.getItem('selectedPacsIndex'));

  const defaultOption = {
    name: 'default',
    wadoRsUrl: appConfig.WADO_RS_ENDPOINT,
    qidoRsUrl: appConfig.QIDO_RS_ENDPOINT,
    ...(appConfig.WADO_URI_ENDPOINT ? { wadoUriUrl: appConfig.WADO_URI_ENDPOINT } : {}),
    ...(appConfig.AUTH_FOR_HEADERS ? { authHeader: appConfig.AUTH_FOR_HEADERS } : {}),
  };

  const pacsConfig = Array.isArray(PACS_SELECTOR_CONFIG) ? PACS_SELECTOR_CONFIG : [defaultOption];

  const options = pacsConfig
    .map((pacs, index) => <option key={pacs.name} value={index}>{pacs.name}</option>);

  const onChangePacsURL = (e) => {
    const nextPacsIndex = Number(e.target.value);
    setSelectedPacsIndex(String(nextPacsIndex));
    sessionStorage.setItem('selectedPacsIndex', String(nextPacsIndex));
    dispatch(allActions.Manager.setSelectedPacsIndex(nextPacsIndex));
    dispatch(addConfig({ authorizationHeader: getAuthHeader(appConfig) }));

    // Remove the PACS selector query parameter after applying it.
    const queryParams = new URLSearchParams(window.location.search);
    const datasourceParam = appConfig.PACS_SELECTOR_IN_URL_PARAM || 'datasource';
    if (queryParams.has(datasourceParam)) {
      queryParams.delete(datasourceParam);
      const remainingQuery = queryParams.toString();
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}${remainingQuery ? `?${remainingQuery}` : ''}${window.location.hash}`
      );
    }

    // StudyLobby observes the Redux selection and runs a new QIDO search.
  };

  return (
    WITH_PACS_SELECTOR && (
      <>
        <label htmlFor="pacs">PACS</label>
        <select id="pacs" name="pacs" value={selectedPacsIndex} onChange={onChangePacsURL}>
          {options}
        </select>
      </>
    )
  );
};

export default React.memo(PacsSelector);
